module.exports = __webpack_public_path__ + "static/img/10020 (2).d7e6769.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10020 (2).webp
// module id = 1XYL
// module chunks = 14